import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

const currentDomain = window.location.hostname;
const validDomains = ["localhost", "vudio"];
const isVudioDomain = validDomains.some((domain) =>
  currentDomain.includes(domain)
);

export const publicRoutes = isVudioDomain
  ? [
      {
        key: "login",
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() =>
          import("views/app-views/vudio/auth-views/authentication/Layout")
        ),
      },
      {
        key: "loginInfluencer",
        path: `${AUTH_PREFIX_PATH}/login/influencer`,
        component: React.lazy(() =>
          import(
            "views/app-views/vudio/auth-views/authentication/Login/Influencer"
          )
        ),
      },
      {
        key: "register",
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() =>
          import("views/app-views/vudio/auth-views/authentication/Layout")
        ),
      },
      {
        key: "forgotPassowrd",
        path: `${AUTH_PREFIX_PATH}/forgotPassword`,
        component: React.lazy(() =>
          import("views/app-views/vudio/auth-views/authentication/Layout")
        ),
      },
      {
        key: "passwordReset",
        path: `${AUTH_PREFIX_PATH}/passwordReset`,
        component: React.lazy(() =>
          import("views/app-views/vudio/auth-views/authentication/Layout")
        ),
      },
      {
        key: "registerInfluencer",
        path: `${AUTH_PREFIX_PATH}/register/influencer`,
        component: React.lazy(() =>
          import(
            "views/app-views/vudio/auth-views/authentication/Signup/Influencer"
          )
        ),
      },

      {
        key: "signUpWithGoogle",
        path: `${AUTH_PREFIX_PATH}/signUpWithGoogle`,
        component: React.lazy(() =>
          import("views/app-views/vudio/auth-views/authentication/Layout")
        ),
      },

      {
        key: "sso-auth",
        path: `${AUTH_PREFIX_PATH}/sso`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/sso")
        ),
      },
      {
        key: "influencer-acceptions",
        path: `${AUTH_PREFIX_PATH}/influencer`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/influencer-invitation")
        ),
      },
      {
        key: "aggregator-acceptions",
        path: `${AUTH_PREFIX_PATH}/aggregator`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/influencer-invitation")
        ),
      },
      {
        key: "amazon-acceptions",
        path: `${AUTH_PREFIX_PATH}/amazon`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/influencer-invitation")
        ),
      },
    ]
  : [
      {
        key: "login",
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/login")
        ),
      },
      {
        key: "resetPassword",
        path: `${AUTH_PREFIX_PATH}/passwordReset`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/reset-password")
        ),
      },
      {
        key: "register",
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/register")
        ),
      },
      {
        key: "forgot-password",
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/forgot-password")
        ),
      },
      {
        key: "sso-auth",
        path: `${AUTH_PREFIX_PATH}/sso`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/sso")
        ),
      },
      {
        key: "influencer-acceptions",
        path: `${AUTH_PREFIX_PATH}/influencer`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/influencer-invitation")
        ),
      },
      {
        key: "aggregator-acceptions",
        path: `${AUTH_PREFIX_PATH}/aggregator`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/influencer-invitation")
        ),
      },
    ];

const vudio_routes = [
  {
    key: "dashboard.default",
    title: "Home",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() =>
      import("views/app-views/vudio/vudio-home-page/MainVudioHomepage")
    ),
  },
  {
    key: "dashboard.socialMedia",
    title: "Social Media",
    path: `${APP_PREFIX_PATH}/dashboards/socialMedia`,
    component: React.lazy(() => import("views/app-views/vudio/dashboard")),
  },
  {
    key: "dashboard.socialMedia.autoPost",
    title: "Social Media",
    path: `${APP_PREFIX_PATH}/dashboards/socialMedia/autoPost`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/BatchMode/BatchModeHome")
    ),
  },
  {
    key: "dashboard.socialMedia.autoPostCreate",
    title: "Social Media",
    path: `${APP_PREFIX_PATH}/dashboards/socialMedia/autoPost/create`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/BatchMode/CreateBatchMode")
    ),
  },
  {
    key: "automationDashboard",
    title: "Automation",
    path: `${APP_PREFIX_PATH}/vudio/automation/dashboard`,
    component: React.lazy(() =>
      import("views/app-views/vudio/automation-dashboard")
    ),
  },
  {
    key: "createPost",
    title: "Create Post",
    path: `${APP_PREFIX_PATH}/posts/create`,
    component: React.lazy(() => import("views/app-views/vudio/CreatePost")),
  },
  {
    key: "publish.webApp.widget",
    title: "Widgets",
    path: `${APP_PREFIX_PATH}/web&App/widgets`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/widgets-dashboard")
    ),
  },
  {
    key: "publish.webApp.widget.create",
    title: "Widgets",
    path: `${APP_PREFIX_PATH}/web&App/widgets/create`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/widgets-dashboard/components/createWidget"
      )
    ),
  },
  {
    key: "publish.webApp.videoLibrary",
    title: "Video Library",
    path: `${APP_PREFIX_PATH}/web&App/videoLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/video-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.productLibrary",
    title: "Product Library",
    path: `${APP_PREFIX_PATH}/web&App/productLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/product-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.collectionLibrary",
    title: "Collection Library",
    path: `${APP_PREFIX_PATH}/web&App/collectionLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/collection-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.customLinkLibrary",
    title: "Custom Link Library",
    path: `${APP_PREFIX_PATH}/web&App/customLinkLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/custom-link-dashboard")
    ),
  },
  {
    key: "publish.webApp.pollLibrary",
    title: "Polls Library",
    path: `${APP_PREFIX_PATH}/web&App/pollLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/poll-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.quizLibrary",
    title: "Quiz Library",
    path: `${APP_PREFIX_PATH}/web&App/quizLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/quiz-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.formLibrary",
    title: "Forms Library",
    path: `${APP_PREFIX_PATH}/web&App/formLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/form-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.storyLibrary",
    title: "Story Library",
    path: `${APP_PREFIX_PATH}/web&App/storyLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/story-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.storyLibrary.create",
    title: "Create Story",
    path: `${APP_PREFIX_PATH}/web&App/storyLibrary/createStory`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/story-library-dashboard/CreateStory"
      )
    ),
  },
  {
    key: "publish.webApp.analytics",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/web&App/analytics`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/analytics-dashboard")
    ),
  },

  {
    key: "publish.webApp.analytics",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/web&App/analytics/configureSteps`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/ConfigureSteps"
      )
    ),
  },

  {
    key: "createAutomation",
    title: "Automation",
    path: `${APP_PREFIX_PATH}/vudio/automation/create`,
    component: React.lazy(() =>
      import("views/app-views/vudio/CreateAutomation")
    ),
  },

  {
    key: "analytics.automation",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/web&App/analytics/automation`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/AutomationAnalytics"
      )
    ),
  },

  {
    key: "analytics.social",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/analytics/socialMedia`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/SocialMediaAnalytics"
      )
    ),
  },
  {
    key: "analytics.livestream",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/analytics/livestream`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/LiveStreamAnalytics"
      )
    ),
  },
  {
    key: "analytics.livestream.summary",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/analytics/livestream-summary`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/LivestreamSummary"
      )
    ),
  },
  {
    key: "analytics.vton.summary",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/analytics/vton-summary`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/VirtualTryonSummary"
      )
    ),
  },
  {
    key: "analytics.aiVideos.summary",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/analytics/ai-videos-summary`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/AIVideosSummary"
      )
    ),
  },
  {
    key: "studio_ai.home",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/home`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/StudioHome/V2")
    ),
  },
  {
    key: "studio_ai.library",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/home`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/StudioLibrary")
    ),
  },
  {
    key: "studio_ai.url_to_video",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/urlTovideo`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/URL_TO_VIDEO")
    ),
  },
  {
    key: "studio_ai.url_to_ai",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/urlToAi`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/URL_TO_AI_AVATAR")
    ),
  },
  {
    key: "studio_ai.image_to_video",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiVideoShoot`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Video_Shoots/V2")
    ),
  },
  {
    key: "studio_ai.image_to_video",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiVideoEditor`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Video_Shoots/V2")
    ),
  },
  {
    key: "studio_ai.batchMode",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/batchMode/home`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/BatchMode/BatchModeHome")
    ),
  },
  {
    key: "studio_ai.batchMode",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/batchMode/create`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/BatchMode/CreateBatchMode")
    ),
  },
  {
    key: "studio_ai.cinematicVideoShoot",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/cinematicVideo`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/CinematicVideoShoots")
    ),
  },
  {
    key: "studio_ai.aiPhotoshoot",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiCatalogue`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AICatalogue/Dashboard")
    ),
  },
  {
    key: "studio_ai.aiPhotoshoot",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiCatalogue/create`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AICatalogue/CreateV1")
    ),
  },
  {
    key: "studio_ai.aiFaceSwap",
    title: "AI Face Swap",
    path: `${APP_PREFIX_PATH}/studioAI/aiFaceSwap`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Face_Swap")
    ),
  },
  {
    key: "studio_ai.aiImageTemplate",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiImageTemplate`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AiImageTemplate")
    ),
  },
  {
    key: "studio_ai.virtualTryon",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/virtualTryon`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/VirtualTryon")
    ),
  },
  {
    key: "studio_ai.virtualTryonDetails",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/vton-job-details`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AICatalogue/VtonDetailsDashboard")
    ),
  },
  {
    key: "studio_ai.virtualTryonBulkUpload",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/virtualTryon/vtonBulkUpload`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Photoshoot_V3/VtonBulkUploadPage")
    ),
  },
  {
    key: "studio_ai.aiImageTemplate",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiImageTemplate/objectReplacer`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AiImageTemplate/ObjectReplacer")
    ),
  },
  {
    key: "studio_ai.aiTextToImage",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiTextToImage`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Text_To_Image")
    ),
  },
  {
    key: "studio_ai.aiPhotoshootv3",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiImageTemplate/aiPhotoshootV3`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Photoshoot_V3")
    ),
  },
  {
    key: "studio_ai.aiImageTemplate",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiImageEditor`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Image_Editor")
    ),
  },
  {
    key: "livestream.home",
    title: "LiveStream",
    path: `${APP_PREFIX_PATH}/livestream/home`,
    component: React.lazy(() => import("views/app-views/vudio/LiveStream")),
  },
  {
    key: "livestream.home",
    title: "LiveStream",
    path: `${APP_PREFIX_PATH}/livestream/create`,
    component: React.lazy(() =>
      import("views/app-views/vudio/LiveStream/Create_LiveStream")
    ),
  },
  {
    key: "accountSettingsDashboard",
    title: "Account Settings",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/accountSettings`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard")
    ),
  },
  {
    key: "usersandPermissions",
    title: "Users and Permissions",

    path: `${APP_PREFIX_PATH}/vudio/generalSettings/usersPermissions`,
    component: React.lazy(() =>
      import("views/app-views/vudio/users-permissions-dashboard")
    ),
  },
  {
    key: "accountSetting.WebAppWidget",
    title: "Web/ App Widgets",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/webAppWidgets`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/Web-App Widget")
    ),
  },
  {
    key: "accountSetting.livestream",
    title: "LiveStream",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/livestream`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/LiveStream")
    ),
  },
  {
    key: "accountSetting.one2one",
    title: "LiveStream",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/oneToone`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/one-to-one")
    ),
  },
  {
    key: "accountSetting.childCompanies",
    title: "Child Companies",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/childCompanies`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/ChildCompanies")
    ),
  },
  {
    key: "accountSetting.storeConfiguration",
    title: "LiveStream",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/storeConfigure`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/accout-settings-dashboard/Store_Configuration"
      )
    ),
  },
  // {
  //   key: "live-call.live-call",
  //   path: `${APP_PREFIX_PATH}/live-call/live-call`,
  //   component: React.lazy(() => import("views/app-views/live-call/livecall")),
  // },
  {
    key: "live-stream.stream",
    path: `${APP_PREFIX_PATH}/live-call/stream`,
    component: React.lazy(() =>
      import("views/app-views/one-to-many/LiveStreamView")
    ),
  },

  {
    key: "subscription-plan",
    path: `${APP_PREFIX_PATH}/vudio/subscription/plan`,
    component: React.lazy(() => import("views/app-views/vudio/billing")),
  },
  {
    key: "verify-plan",
    path: `${APP_PREFIX_PATH}/subscription/verify`,
    component: React.lazy(() =>
      import("views/app-views/shopify-plans/VerifyToken.js")
    ),
  },
  {
    key: "creditHistory",
    path: `${APP_PREFIX_PATH}/vudio/creditHistory`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/CreditHistory")
    ),
  },
  {
    key: "adminPlans",
    path: `${APP_PREFIX_PATH}/admin/plans`,
    component: React.lazy(() => import("views/app-views/vudio/AdminPlan")),
  },
  {
    key: "adminApiSwitch",
    path: `${APP_PREFIX_PATH}/admin/apiSwitch`,
    component: React.lazy(() => import("views/app-views/vudio/AdminAISwitch")),
  },
  {
    key: "adminBrandListing",
    path: `${APP_PREFIX_PATH}/admin/brandListing`,
    component: React.lazy(() =>
      import("views/app-views/vudio/AdminBrandListing")
    ),
  },

  {
    key: "ai-agents",
    path: `${APP_PREFIX_PATH}/ai-agents`,
    component: React.lazy(() => import("views/app-views/vudio/AIAgentsV2")),
  },
  {
    key: "gemini-test-dashboard",
    path: `${APP_PREFIX_PATH}/admin/gemini-test-dashboard`,
    component: React.lazy(() =>
      import("views/app-views/vudio/admin-specific-views/gemini-test-dashboard")
    ),
  },
  {
    key: "vton-categories-dashboard",
    path: `${APP_PREFIX_PATH}/admin/vton-categories-dashboard`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/admin-specific-views/vton-category-management"
      )
    ),
  },
  {
    key: "background-management",
    path: `${APP_PREFIX_PATH}/admin/background-management`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/admin-specific-views/background-management"
      )
    ),
  },
  {
    key: "under-development",
    path: `${APP_PREFIX_PATH}/coming-soon`,
    component: React.lazy(() =>
      import("views/app-views/vudio/under-development")
    ),
  },
  {
    key: "tutorial",
    path: `${APP_PREFIX_PATH}/tutorial`,
    component: React.lazy(() => import("views/app-views/vudio/tutorial")),
  },
  {
    key: "content-library",
    path: `${APP_PREFIX_PATH}/content-library`,
    component: React.lazy(() =>
      import("views/app-views/vudio/content-library")
    ),
  },
  {
    key: "appstore",
    path: `${APP_PREFIX_PATH}/appstore`,
    component: React.lazy(() => import("views/app-views/vudio/AppStore")),
  },
  {
    key: "ai-ads",
    path: `${APP_PREFIX_PATH}/ai-ads`,
    component: React.lazy(() => import("views/app-views/vudio/AIAds")),
  },
  {
    key: "ai-ads-creation",
    path: `${APP_PREFIX_PATH}/ai-ads/creation`,
    component: React.lazy(() => import("views/app-views/vudio/AIAds/create")),
  },
];

export const protectedRoutes = isVudioDomain ? vudio_routes : [];

export const getTitleForCurrentPath = () => {
  const pathname = window.location.pathname;

  const matchedRoute = vudio_routes.find((route) => route.path == pathname);

  return matchedRoute ? matchedRoute?.title : "Default Title";
};
